import useSession, { useCustomer, useStaff, useStore } from 'hooks/useSession'
import { useEffect } from 'react'
import Analytics from './Analytics'

const useSessionTracking = () => {
  const customer = useCustomer()
  const staff = useStaff()
  const store = useStore()
  const sessionId = useSession((state) => state.sessionId)

  useEffect(() => {
    Analytics.setCustomer(customer || null)
  }, [customer])

  useEffect(() => {
    Analytics.setStaff(staff || null)
  }, [staff])

  useEffect(() => {
    Analytics.setStore(store || null)
  }, [store])

  useEffect(() => {
    Analytics.setSession(sessionId)
  }, [sessionId])
}

export default useSessionTracking
